import React, { useState } from 'react';
import { connect } from 'react-redux';
import { removeHtmlTags } from '../../utilities/methods';
import { ToastContainer, toast } from "react-toastify";
import * as rooRTC from "../../services/roomRTC";

import Accordion from '../Accordion/Accordion';
import ImageViewer from './ImageViewer';
import Label from '../Accordion/Label';

import "./Room.css";

const SingleQuestion = ({ index, question, roomId }) => {
    const [clickedIndexes, setClickedIndexes] = useState(new Set());

    const notify = (message) => {
        toast(message);
    };

    const handlerSendCard = (question) => {
        setClickedIndexes(prevIndexes => {
            const newSet = new Set(prevIndexes);

            if (!newSet.has(index)) {
                newSet.add(index);

                if (question) {
                    const id = question.id;
                    const cardId = question.cardId;
                    const perguntaRealizada = question.perguntaRealizada;
                    const resposta = question.resposta;
                    const palavrasChaves = question.palavrasChaves;
                    const resumo = question.resumo;
                    const imagem = question.imagem;
                    const nota_A = question.nota_A;
                    const nota_PA = question.nota_PA;
                    const nota_I = question.nota_I;
                    const tipo = question.tipo;
                    const dica = question.dica;
                    const ativo = question.ativo;
                    const ordem = question.ordem;

                    rooRTC.sendQuestionDataChannel(id, cardId, perguntaRealizada, resposta, palavrasChaves,
                        resumo, imagem, nota_A, nota_PA, nota_I, tipo, dica, ativo, ordem, roomId);
                }
            } else {
                notify("O Impresso selecionado já foi enviado.");
            }

            return newSet;
        });
    };

    return (
        <Accordion>
            <Accordion.Item>
                <Accordion.Header>
                    <div className='question_col_card_content question_col_card_start'>
                        <Label text={removeHtmlTags(question.perguntaRealizada)} />
                    </div>
                </Accordion.Header>
                <Accordion.Body>
                    <div className="question_col_card_content question_col_card_end mb-2" onClick={() => handlerSendCard(question)}>
                        <span className={`material-symbols-outlined btn_question_col_card_end ${!clickedIndexes.has(index) ? "" : "send"}`}>
                            {!clickedIndexes.has(index) ? "share_windows" : "task_alt"}
                        </span>
                    </div>

                    <ImageViewer
                        mediaFile={question.imagem}
                    />
                </Accordion.Body>
            </Accordion.Item>
        </Accordion>
    );
};

const ScenarioQuestions = ({ isRoomHost, questions, roomId }) => {
    if (!Array.isArray(questions) || questions.length === 0) {
        return null;
    }

    return (
        <div className='col-md-12'>
            {
                isRoomHost &&
                questions.filter((question, index, self) => index === self.findIndex((q) => (
                    q.perguntaRealizada === question.perguntaRealizada
                )))
                    .filter((question) => removeHtmlTags(question.perguntaRealizada).toLocaleLowerCase().includes("impresso -"))
                    .map((question, index) => (
                        <SingleQuestion
                            key={`${question.perguntaRealizada}-${index}`}
                            index={index}
                            question={question}
                            roomId={roomId}
                        />
                    ))
            }

            <ToastContainer
                theme="dark"
                autoClose={3000}
                closeButton={false}
                position="top-right"
            />
        </div>
    );
};

const mapStoreToProps = (state) => {
    return {
        ...state
    };
};

export default connect(mapStoreToProps)(ScenarioQuestions);